import type { BrandingCreate } from '@domain/schemas/branding.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateBrandingResponse } from '@responses/brandings';
import axios from 'axios';

export const createBranding = async (data: BrandingCreate): Promise<CreateBrandingResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: '/brandings',
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
